import { Link } from "react-router-dom";

type Props = {
  icon?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
};

export default function EmptyState({ icon = "ri-inbox-line", title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="mt-5 text-lg font-semibold text-foreground-900">{title}</h3>
      {description ? (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      ) : null}
      {action ? (
        <Link
          to={action.to}
          className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line"></i>
          {action.label}
        </Link>
      ) : null}
    </div>
  );
}